module.exports = __webpack_public_path__ + "static/middle-920022a74b967ee8399dd15e8107ad44.png";